<script setup>
const props = defineProps(["section"]);
import store from "../store.js";

</script>

<template>
    <div class="product-compare-grid mt-24 px-12 product-compaer-section">
        <div
            v-for="(printer, index) in store.selectedPrinters"
            :key="index"
            class="product-compare-section"
            :class="{ loaded: printer }"
        >
            <div class="product-compare-heading text-md is-medium">
                {{ props.section.label }}
            </div>

            <div
                v-if="
                    printer &&
                    printer.stats &&
                    printer.stats[props.section.id]?.length
                "
            >
                <p v-for="stat in printer.stats[props.section.id]" class="mt-8">
                    {{ stat }}
                </p>
            </div>

            <p v-else class="mt-12 is-regular">&mdash;</p>
        </div>
    </div>
</template>
